// Shared data for the v2 landing page. WHATSAPP_URL and openWhatsApp moved to
// src/whatsapp.ts so the floating IconeZapZap button shares the exact same
// entry point - and therefore the same conversion tracking. Re-exported here
// because every v2 section imports them from this module.
export { WHATSAPP_URL, openWhatsApp } from '../whatsapp'

export const WHATSAPP_DISPLAY = '(84) 99127-0936'
export const INSTAGRAM_URL = 'https://www.instagram.com/fonoonlinefrancis/'
export const YOUTUBE_URL = 'https://www.youtube.com/@fonoonlinefrancis'

export const NAV_LINKS = [
  { label: 'Início', href: '#inicio' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Dúvidas', href: '#duvidas' },
]
